export default __webpack_public_path__ + "static/media/plus_square.6bc19280.svg";